if (!customElements.get('nw-collection-pagination')) {
  customElements.define('nw-collection-pagination', class extends HTMLElement {
    static observedAttributes = ['data-page', 'data-total', 'data-page-size'];

    connectedCallback() {
      this.grid = this.closest('results-list')?.querySelector('.product-grid');
      if (!this.grid) return;
      this.onClick = this.handleClick.bind(this);
      this.onPop = () => {
        const page = Number(new URL(location.href).searchParams.get(this.dataset.pageParam)) || 1;
        if (page !== Number(this.dataset.page)) return location.reload();
        this.slice = undefined;
        this.schedule();
      };
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onPop);
      this.resizeObserver = new ResizeObserver(() => this.schedule());
      this.resizeObserver.observe(this.grid);
      this.mutationObserver = new MutationObserver(() => this.schedule());
      this.mutationObserver.observe(this.grid, { childList: true, attributes: true, attributeFilter: ['style', 'class', 'product-grid-view'] });
      this.schedule();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('popstate', this.onPop);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    attributeChangedCallback() {
      if (!this.isConnected || !this.grid) return;
      this.slice = 1;
      this.schedule();
    }

    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.render());
    }

    render() {
      if (!this.isConnected || !this.grid) return;
      const cards = Array.from(this.grid.querySelectorAll(':scope > .product-grid__item'));
      const tracks = getComputedStyle(this.grid).gridTemplateColumns;
      const columns = Math.max(1, tracks.split(/\s+/).filter(Boolean).length);
      const size = columns * 6;
      const baseSize = Number(this.dataset.pageSize);
      const basePage = Number(this.dataset.page);
      const total = Number(this.dataset.total);
      if (!baseSize || !total) return;
      const slicesPerPage = Math.ceil(baseSize / size);
      const basePages = Math.ceil(total / baseSize);
      const lastCount = total - (basePages - 1) * baseSize;
      const totalPages = (basePages - 1) * slicesPerPage + Math.ceil(lastCount / size);
      const availableSlices = Math.max(1, Math.ceil(cards.length / size));
      if (this.slice === undefined) this.slice = Number(new URL(location.href).searchParams.get('nw_slice')) || 1;
      if (this.columns && this.columns !== columns) this.slice = 1;
      this.columns = columns;
      this.slice = Math.max(1, Math.min(this.slice, availableSlices));
      cards.forEach((card, index) => {
        const hidden = index < (this.slice - 1) * size || index >= this.slice * size;
        if (card.hasAttribute('data-nw-page-hidden') !== hidden) card.toggleAttribute('data-nw-page-hidden', hidden);
      });
      const current = (basePage - 1) * slicesPerPage + this.slice;
      const nav = this.querySelector('nav');
      nav.hidden = totalPages <= 1;
      this.style.padding = totalPages <= 1 ? '0' : '';
      this.querySelector('[data-page-current]').textContent = current;
      this.querySelector('[data-page-total]').textContent = totalPages;
      this.setLink(this.querySelector('[data-page-previous]'), current > 1,
        this.slice > 1 ? basePage : basePage - 1, this.slice > 1 ? this.slice - 1 : slicesPerPage);
      this.setLink(this.querySelector('[data-page-next]'), current < totalPages,
        this.slice < availableSlices ? basePage : basePage + 1, this.slice < availableSlices ? this.slice + 1 : 1);
    }

    setLink(link, enabled, page, slice) {
      link.setAttribute('aria-disabled', String(!enabled));
      if (!enabled) {
        link.removeAttribute('href');
        link.tabIndex = -1;
        return;
      }
      link.removeAttribute('tabindex');
      const url = new URL(location.href);
      url.searchParams.set(this.dataset.pageParam || 'page', String(page));
      if (slice > 1) url.searchParams.set('nw_slice', String(slice));
      else url.searchParams.delete('nw_slice');
      url.hash = 'ResultsList';
      link.href = url.href;
    }

    handleClick(event) {
      const link = event.target.closest('a');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      const url = new URL(link.href);
      if (Number(url.searchParams.get(this.dataset.pageParam)) !== Number(this.dataset.page)) return;
      event.preventDefault();
      this.slice = Number(url.searchParams.get('nw_slice')) || 1;
      history.pushState({}, '', url);
      this.render();
      this.grid.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
  });
}
